// extracted by mini-css-extract-plugin
export default {"menuWrap":"_31c443","menuWrap__mobile":"_3LpkOG","col":"_3Ymfl0","link":"_18BRfB","label":"v3qoGL","carrot":"_3hxBn_","up":"_2OvGgC","content":"_1LxVpo","open":"_1aXQKF"};